import type { ComponentProps } from "react";

import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-sm text-xs leading-none font-semibold shrink-0",
  {
    variants: {
      variant: {
        "orange": ["bg-orange-100 text-orange-500"],

        "orange-dark": ["text-white bg-orange-500"],

        "blue": ["bg-blue-200 text-blue-500"],

        "blue-dark": ["text-white bg-blue-500"],

        "purple": ["bg-purple-200 text-purple-500"],

        "purple-dark": ["text-white bg-[#CC33C2]"],

        "grey": ["bg-neutral-100 text-neutral-500"],
      },
      size: {
        default: "h-5 px-2",
        compact: "h-5 w-5 p-0",
      },
    },
    defaultVariants: {
      variant: "orange",
      size: "default",
    },
  },
);

type BadgeProps = ComponentProps<"div"> & VariantProps<typeof badgeVariants>;

export function Badge({
  children,
  className,
  variant,
  size,
  ...props
}: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size, className }))} {...props}>
      {children}
    </div>
  );
}
